import * as React from 'react';

export function ManageRolePermissionsTable() {
    return (
        <div>
            <div>Manage role permissions table</div>
        </div>
    );
}
